export const environment: any = {    
    prd: {
        adal: {
            tenant: '8db8eb94-00a5-42b3-a1b0-429086455cb4',
            clientId: 'f9cadfec-ad1b-4441-8387-487d65dfd399'
        },
        auth: {
            token: '',
            ocpkey: 'e4ee61a8fe244a04a0a07340b4283515',
            versionApp: '2.25.0',
            versionAppPrevious: '2.25.0',         
        },
        url: {
            host: window.location.origin,
            graph: 'https://apiurpiapp.mibanco.com.pe/orq/graphql/',
            apim: 'https://apiurpiapp.mibanco.com.pe/upload/'
        },
        downloadKey: "?sv=2020-08-04&ss=b&srt=o&sp=r&se=2023-10-20T22:04:38Z&st=2021-10-20T14:04:38Z&spr=https&sig=D%2BPTtaV3yZG2oyOlmRsPhG1D6D8vjVPH8WMXLcP4lLA%3D",
        firebase:{
            apiKey: "AIzaSyAWNrPgkNQVdYn8ty58Hkv73J4h11UUNKA",
            authDomain: "http://urpi-adc.firebaseapp.com",
            databaseURL: "https://urpi-adc.firebaseio.com",
            projectId: "urpi-adc",
            storageBucket: "http://urpi-adc.appspot.com",
            messagingSenderId: "719363555253",
            appId: "1:719363555253:web:72276837312c82dbcaa3fc",
            measurementId: "G-N6WX1FBRFT"
        }
    },

   // buildConfigField "String", "BASE_URL_USADA", '"https://apiqaurpiapp.mibanco.com.pe/msorq01/graphql"'
   // buildConfigField "String", "URL_ANALITICA", '"https://apiqaurpiapp.mibanco.com.pe/analitica01/"'
   // buildConfigField "String", "URL_UPLOAD", '"https://apiqaurpiapp.mibanco.com.pe/upload01/"'
  //  buildConfigField "String", "URL_INTEGRITY", '"https://apiqaurpiapp.mibanco.com.pe/seguridad01/"'



    qa: {
        adal: {
            tenant: '8db8eb94-00a5-42b3-a1b0-429086455cb4',
            clientId: 'f9cadfec-ad1b-4441-8387-487d65dfd399'
        },
        auth: {
            token: '',
            ocpkey: 'd24e01ea8c084f1a80c70141e9a7418f',
            versionApp: '4.3.0',
            versionAppPrevious: '4.1.0',         
        },
        url: {
            host: window.location.origin,
            graph: 'https://apiqaurpiapp.mibanco.com.pe/msorq01/graphql/',
            apim: 'https://apiqaurpiapp.mibanco.com.pe/upload01'
        },
        downloadKey: "?sv=2020-08-04&ss=b&srt=o&sp=rc&se=2023-12-23T21:46:49Z&st=2021-12-23T13:46:49Z&spr=https&sig=B3OyzJNc6NPcCfdcQDwofUlSSGInsW7iE4ssNs03Y4Y%3D",
        firebase: {
            apiKey: 'AIzaSyACGYeagijBxKx0mu9Vjr1l-wLgkQiNnYU',
            authDomain: 'urpiapp-qa.firebaseapp.com',
            databaseURL: 'https://urpiapp-qa.firebaseio.com',
            projectId: 'urpiapp-qa',
            storageBucket: 'urpiapp-qa.appspot.com',
            messagingSenderId: '131079929697',
            appId: '1:131079929697:web:a0356c1d3106ac58da8f20',
            measurementId: 'G-2KW65HMC35'
          }
    },
    local: {
        adal: {
            tenant: '8db8eb94-00a5-42b3-a1b0-429086455cb4',
            clientId: 'f9cadfec-ad1b-4441-8387-487d65dfd399'
        },
        auth: {
            token: '',
            ocpkey: 'c5b960ef950342ee84d35bc15d45f636',
            versionApp: '4.1.1',
            versionAppPrevious: '4.1.0',         
        },
        url: {
            host: window.location.origin,
            graph: 'https://apim-urpi-dev-001.azure-api.net/msorq01/graphql/',
            apim: 'https://apim-urpi-dev-001.azure-api.net/upload'
        },
        downloadKey: "?sv=2020-08-04&ss=b&srt=o&sp=rc&se=2023-12-23T21:46:49Z&st=2021-12-23T13:46:49Z&spr=https&sig=B3OyzJNc6NPcCfdcQDwofUlSSGInsW7iE4ssNs03Y4Y%3D",
        firebase: {
            apiKey: 'AIzaSyACGYeagijBxKx0mu9Vjr1l-wLgkQiNnYU',
            authDomain: 'urpiapp-qa.firebaseapp.com',
            databaseURL: 'https://urpiapp-qa.firebaseio.com',
            projectId: 'urpiapp-qa',
            storageBucket: 'urpiapp-qa.appspot.com',
            messagingSenderId: '131079929697',
            appId: '1:131079929697:web:a0356c1d3106ac58da8f20',
            measurementId: 'G-2KW65HMC35'
          }
    }
}
/* CONSTANTE PARA INDICAR AMBIENTE */
export const urpiweb: any = environment.prd;

export const localeConfig = {
    rangePicker: {
        local: {
            format: 'DD/MM/YYYY',
            separator: '  hasta  ',
            cancelLabel: 'Cancelar',
            applyLabel: 'Aceptar',
            firstDay: 1
        }
    }
}

export const error = {
    message : {
        session: "Tu sesión ha expirado.",
        generic: "Se ha producido un error, inténtalo nuevamente.",
        notConection: "No tienes conexión, intenta buscar cobertura.",
        fileNotAvailable: 'Archivo no se encuentra disponible.'
    },
    statusResponse : {
        OK: "OK",
        ERROR: "ERROR",
        WARNING: "WARNING"
    }
}

export const constUrpi = {
    hashKey: "0;^WY!kZ#6%D+w,5<X}meD:0y:}_NN}P",
    downloadKey: "?sv=2020-08-04&ss=b&srt=o&sp=rc&se=2023-12-23T21:46:49Z&st=2021-12-23T13:46:49Z&spr=https&sig=B3OyzJNc6NPcCfdcQDwofUlSSGInsW7iE4ssNs03Y4Y%3D",
    aplicacionId: 2,
    proceso: {
        notipdf: "NOTIPDF"
    },
    contentType: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    typeMessageDialog: {
        INFO: 0,
        WARNING: 1,
        ERROR: 2,
        SESSION: 3,
        CONFIRMATION: 4
    },
    role: {
        ABS: "ABS",
        ADN: "ADN",
        AGE: "AGE",
        AGP: "AGP",
        APW: "APW",
        AUR: "AUR",
        EBS: "EBS",
        JBS: "JBS",
        NOT: "NOT",
        UCE: "UCE",
        UDE: "UDE",
        UEN: "UEN"
    },
    module: {
        admPerfilWeb: "adm_perfil_web",
        visitasWeb: "visitas_web",
        notifWeb: "notif_web",
        proRropeWeb: "pro_rope_web",
        prospectoWeb: "prospecto_web"
    }
}

export const module = {
    prospecto: {
        PROSPECTO_BANDEJA: {
            PANTALLA_PROSPECTO_OPERACIONES_BANDEJA: "PROSPECTO_OPERACIONES-BANDEJA",
            EVENTO_IR_A_INFORMACION_DEL_PROSPECTO: "IR_A_INFORMACION_DEL_PROSPECTO",
            EVENTO_IR_A_PROSPECTO_BUSCAR: "IR_A_PROSPECTO_BUSCAR",
            EVENTO_VALIDAR_PROSPECTO: "VALIDAR_PROSPECTO"
        },
        PROSPECTO_INFORMACION: {
            PANTALLA_PROSPECTO_OPERACIONES_INFORMACION: "PROSPECTO_OPERACIONES-INFORMACION",
            EVENTO_MOSTRAR_INFORMACION_DEL_PROSPECTO: "MOSTRAR_INFORMACION_DEL_PROSPECTO"
        },
        PROSPECTO_BUSCAR: {
            PANTALLA_PROSPECTO_OPERACIONES_BUSCAR: "PROSPECTO_OPERACIONES-BUSCAR",
            EVENTO_BUSCAR_PROSPECTO_POR_DNI: "BUSCAR_PROSPECTO_POR_DNI",
            EVENTO_VALIDAR_PROSPECTO: "VALIDAR_PROSPECTO"
        },
        PROSPECTO_INGRESAR_DATOS: {
            PANTALLA_PROSPECTO_OPERACIONES_INGRESAR_DATOS: "PROSPECTO_OPERACIONES-INGRESAR_DATOS",
            EVENTO_MOSTRAR_FORMULARIO: "MOSTRAR_FORMULARIO_INGRESO_PROSPECTO",
            EVENTO_GUARDAR_NUEVO_PROSPECTO: "GUARDAR_NUEVO_PROSPECTO"
        }
    },
    visita: {
        ADMINISTRACION_VISITA_WEB: {
            PANTALLA_ADMINISTRACION_CARGA_VISITA_WEB: "ADMINISTRACION_CARGA_VISITA_WEB",
            EVENTO_CARGA_EXCEL_VISITA_POST_WEB: "CARGA_EXCEL_VISITA_POST_WEB",
            EVENTO_DESCARGA_EXCEL_VISITAS_WEB: "DESCARGA_EXCEL_VISITAS_WEB",
            EVENTO_BUSCAR_VISITAS_WEB: "BUSCAR_VISITAS_WEB"
        }
    },
    perfiles:{
        EQUIPOS_Y_PERFILES: {
            PANTALLA_EQUIPOS_PEFILES: "PANTALLA_EQUIPOS_PEFILES",
            EVENTO_FILTRAR: "FILTRAR",
            EVENTO_REGISTRAR: "REGISTRAR",
            EVENTO_BORRAR: "BORRAR",
            EVENTO_EDITAR: "EDITAR",
            EVENTO_CONFIRMAR_BORRAR: "CONFIRMAR_BORRAR",
            PANTALLA_DETALLE_USUARIO: "PANTALLA_DETALLE_USUARIO",
            EVENTO_CONFIRMAR_EDICION: "CONFIRMAR_EDICION",
            EVENTO_CONFIRMAR_REGISTRAR: "CONFIRMAR_REGISTRAR",
            EVENTO_DESCARGA_EXCEL_ADM_PERFILES_WEB: "DESCARGA_EXCEL_ADM_PERFILES_WEB",

        },
        SOLICITUDES_PENDIENTES: {
            PANTALLA_SOLICITUDES_PENDIENTES: "PANTALLA_SOLICITUDES_PENDIENTES",
            PANTALLA_HISTORIAL_SOLICITUDES_PENDIENTES: "PANTALLA_HISTORIAL_SOLICITUDES_PENDIENTES",
            EVENTO_BUSCAR_SOLICITUDES_PENDIENTES: "BUSCAR_SOLICITUDES_PENDIENTES_WEB",
            EVENTO_LIMPIAR_FILTROS: "LIMPIAR_FILTROS",
            EVENTO_VER_HISTORIAL: "VER_HISTORIAL",
            EVENTO_RECHAZAR: "RECHAZAR",
            EVENTO_APROBAR: "APROBAR",
            EVENTO_CONFIRMAR_APROBAR: "CONFIRMAR_APROBAR",
            EVENTO_CONFIRMAR_RECHAZAR: "CONFIRMAR_RECHAZAR"
        }

    },
    notificaciones:{
        REGISTRAR: {
            PANTALLA_REGISTRAR_NOTIFICACIONES: "PANTALLA_REGISTRAR_NOTIFICACIONES",
            EVENTO_REGISTRAR: "EVENTO_REGISTRAR"
        },
        BUSCAR_NOTIFICACION:{
            PANTALLA_BUSCAR_NOTIFICACIONES: "PANTALLA_BUSCAR_NOTIFICACIONES",
            EVENTO_BUSCAR:"BUSCAR"
        }
    }
}
